import React, { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  useMediaQuery,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { isIOS } from "../../hooks/PWA/pwaUtils";

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showBanner, setShowBanner] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    // iOS에서는 PWA 설치 프롬프트를 완전히 비활성화
    if (isIOS()) {
      return;
    }

    const handleBeforeInstallPrompt = (event: Event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setShowBanner(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  // iOS에서는 아예 배너를 표시하지 않음
  useEffect(() => {
    if (isIOS()) {
      setShowBanner(false);
      return;
    }

    // Android Chrome에서만 설치 배너 표시
    if (isMobile && !isIOS()) {
      setShowBanner(true);
    }
  }, [isMobile]);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }
        setDeferredPrompt(null);
        setShowBanner(false);
      });
    }
  };

  const handleCancelClick = () => {
    setDeferredPrompt(null);
    setShowBanner(false);
  };

  const renderButtons = () => (
    <Box>
      {deferredPrompt && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleInstallClick}
          style={{
            width: isMobile ? "100%" : "auto",
            marginBottom: isMobile ? "10px" : "0",
          }}
        >
          설치
        </Button>
      )}
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleCancelClick}
        style={{
          width: isMobile ? "100%" : "auto",
          marginLeft: isMobile ? "0" : "10px",
        }}
      >
        닫기
      </Button>
    </Box>
  );

  // iOS이거나 모바일이 아닐 경우 아무것도 표시하지 않음
  if (!isMobile || isIOS()) {
    return null;
  }

  return (
    <Slide direction="up" in={showBanner} mountOnEnter unmountOnExit>
      <AppBar
        position="fixed"
        color="default"
        style={{ top: "auto", bottom: 0 }}
      >
        <Toolbar
          style={{
            justifyContent: "space-between",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <Typography
            variant="body1"
            align="center"
            style={{ marginBottom: isMobile ? "10px" : "0" }}
          >
            인바디 예약앱을 설치하시겠습니까?
          </Typography>
          {renderButtons()}
        </Toolbar>
      </AppBar>
    </Slide>
  );
};

export default PWAInstallPrompt;
